import React, { useState } from 'react';
import SwipeCard from './SwipeCard';
import { FeedbackOverlay } from './GameElements';

export default function WelcomeScreen({ onClose }) {
  const [showFeedback, setShowFeedback] = useState(false);
  const [lastCorrect, setLastCorrect] = useState(null);
  const [imgError, setImgError] = useState(false);

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'var(--app-bg-accent)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000,
      padding: '32px 16px',
      boxSizing: 'border-box',
    },
    introCard: {
      width: 'min(520px, 100%)',
      color: 'var(--app-text)',
      textAlign: 'center',
      marginBottom: '20px',
    },
    title: {
      margin: '0 0 10px',
      fontSize: '2rem',
      lineHeight: 1.1,
    },
    subtitle: {
      margin: 0,
      color: 'var(--app-text-muted)',
      lineHeight: 1.5,
      fontSize: '1rem',
    },
    logo: {
      display: 'block',
      width: '100%',
      maxWidth: '220px',
      height: 'auto',
      margin: '0 auto',
      objectFit: 'contain',
    },
    logoWrap: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '140px',
      padding: '8px 0 4px',
      boxSizing: 'border-box',
    },
    fallbackText: {
      fontSize: '1.8em',
      fontWeight: 'bold',
      width: '90%',
      textAlign: 'center',
      color: 'var(--app-text)',
      margin: '0 auto',
    }
  };

  const handleSwipe = async (isCorrect) => {
    setLastCorrect(true); // Always show correct feedback
    setShowFeedback(true);
    await new Promise(resolve => setTimeout(resolve, 300));
    setShowFeedback(false);
    onClose();
  };

  const renderLogo = () => {
    if (imgError) {
      return <div style={styles.fallbackText}>Quick Study!</div>;
    }

    return (
      <div style={styles.logoWrap}>
        <img
          src="/logo512.png"
          srcSet="/logo192.png 192w, /logo512.png 512w"
          sizes="(max-width: 600px) 192px, 220px"
          onError={(e) => {
            e.currentTarget.onerror = null; // Prevent infinite loop
            setImgError(true);
          }}
          alt="Quick Study Logo"
          style={styles.logo}
          draggable={false}
        />
      </div>
    );
  };

  return (
    <>
      <div style={styles.overlay}>
        <FeedbackOverlay isCorrect={lastCorrect} show={showFeedback} />
        <div style={styles.introCard}>
          <h1 style={styles.title}>QuickStudyGame</h1>
          <p style={styles.subtitle}>
            Swipe the side with the correct answer.
          </p>
        </div>
        <SwipeCard
          word={renderLogo()}
          incorrect="Left side"
          answer="Right side"
          onSwipe={handleSwipe}
          isVisible={true}
        />
      </div>
    </>
  );
}
